import { render } from "./CreateRecordPopUp.vue?vue&type=template&id=216b9d00&scoped=true"
import script from "./CreateRecordPopUp.vue?vue&type=script&lang=js"
export * from "./CreateRecordPopUp.vue?vue&type=script&lang=js"

import "./CreateRecordPopUp.vue?vue&type=style&index=0&id=216b9d00&scoped=true&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216b9d00"]])

export default __exports__